export default {
    mvpIntro: 'MVP ของคาบเรียนนี้คือ ~',
    buttons: {
        show: 'ดู',
    },
};
